import { render, staticRenderFns } from "./AssessmentSeatStatus.vue?vue&type=template&id=ed027d28"
import script from "./AssessmentSeatStatus.vue?vue&type=script&lang=js"
export * from "./AssessmentSeatStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports